<template>
<div class="chapter">
<div class="inner_page">
<p class="tit1"><a id="page_i"></a>Civil War Monuments</p>
<p class="tit2">and Memory</p>
<p class="stit1">Favorite Stories and Fresh Perspectives</p>
<p class="stit1">from the Historians at Emerging Civil War</p>
<p class="edi1">Edited by</p>
<p class="edi2">Jonathan Tracey &amp; Chris Mackowski</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?061bf207